import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import OurServicesSection from './components/OurServicesSection';
import WhyNeedSection from './components/WhyNeedSection';
import CTASection from './components/CTASection';
import HowWeWorkSection from './components/HowWeWorkSection';
import PricingSection from './components/PricingSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import BenefitsSection from './components/BenefitsSection';
import BlogSection from './components/BlogSection';
import Footer from './components/Footer';
import ContactFormDialog from './components/ContactFormDialog';
import { Toaster } from './components/ui/toaster';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import BlogPost from './pages/BlogPost';

function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const openForm = () => setIsContactFormOpen(true);

  return (
    <div className="bg-[#030308]">
      <div className="noise-overlay" />
      <Header onOpenContactForm={openForm} />
      <HeroBanner />
      <WhyNeedSection onOpenContactForm={openForm} />
      <OurServicesSection onOpenContactForm={openForm} />
      <HowWeWorkSection />
      <CTASection
        onOpenContactForm={openForm}
        heading="Your Competitors Are Already Protected. Are You?"
        paragraph="Every day without a registered trademark is another day your brand is at risk. Stop waiting. Our attorneys file applications within 24 hours."
        buttonText="Register My Trademark Now"
      />
      <PricingSection onOpenContactForm={openForm} />
      <CTASection
        onOpenContactForm={openForm}
        heading="Amazon Sellers: You're Losing Money Without Brand Registry"
        paragraph="Hijackers, counterfeiters, and listing thieves cost Amazon sellers thousands every month. A registered trademark is your key to Brand Registry and full brand protection."
        buttonText="Get Brand Registry Access"
      />
      <WhyChooseUsSection onOpenContactForm={openForm} />
      <BenefitsSection />
      <TestimonialsSection />
      <BlogSection />
      <FAQSection />
      <Footer onOpenContactForm={openForm} />
      <ContactFormDialog isOpen={isContactFormOpen} onClose={() => setIsContactFormOpen(false)} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
